import { useMutation, UseMutationResult } from '@taxdown/zeno-sama-query';
import PreviousYearsService from 'Services/previousYears';
import { PueblaPreviousYearsResponse } from 'Services/sat/types';
import { history } from 'Store';
import { PreviousYearsResultType, PreviousYearStatus } from 'Containers/PreviousYears/types';
import { routes } from 'Constants/routes';
import { QueryKeys } from 'Types/common';

export const useFetchUpdatePreviousYearsRequest = (
  data?: PueblaPreviousYearsResponse
): UseMutationResult<unknown, unknown, unknown, unknown> =>
  useMutation([QueryKeys.GET_PREVIOUS_YEAR], PreviousYearsService.getPreviousYearUser, {
    onSuccess: () => {
      const stage = data?.stage;
      const refundType = data?.refundStatusType;
      const isSubmitted = stage === PreviousYearStatus.SUBMITTED;
      const isToReturn =
        (stage === PreviousYearStatus.CALCULATING || stage === PreviousYearStatus.READY) &&
        refundType === PreviousYearsResultType.TO_RETURN;

      const routeToGo = isSubmitted
        ? routes.PREVIOUS_YEARS_WORKING
        : isToReturn
          ? routes.PREVIOUS_YEARS_CALCULATING_LOADER
          : routes.DATAGATHERING_LOADER;

      history.push(routeToGo, {
        products: {
          isPreviousYear: true,
          request: true,
        },
      });
    },
  });
